module.exports = __webpack_public_path__ + "static/talks1-6a4f2409f9792edc5e107369096f6e5b.jpg";